var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.periodComponentName
    ? _c(_vm.periodComponentName, { tag: "component" })
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }